import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';

import { fromCarl } from 'src/app/store/common/common.selectors';

import { NbaConditionResolver } from '../nba-condition-resolver.interface';

import { NbaConditionResolverId } from './nba-condition-resolver-id.enum';

/**
 * Resolver to be used for Permanent NBAs Similar Cars.
 *
 * There are two similar resolvers available:
 * - IsSimilarStockCarsAvailable
 * - IsSimilarStockCarsAvailableAtAll
 *
 * Differences:
 * IsSimilarStockCarsAvailable requires the compare component to be loaded already!
 * It checks if there are already similar vehicles available in our store
 * If the compare teaser is available just on summary and the user still is on the entry page (motorization),
 * the component is not yet loaded, so no corresponding info in the store yet.
 * This resolver only checks, if the compare component is enabled via config.
 *
 * TODO: consider renaming this resolver to sth. like 'isCompareEnabled'. This requires to adjust the identifier and all config files.
 */
@Injectable()
export class IsSimilarStockCarsAvailableAtAllResolver implements NbaConditionResolver {
  public readonly identifier: string = NbaConditionResolverId.IsSimilarStockCarsAvailableAtAll;

  public constructor(private readonly store: Store) {}

  /**
   * @returns true if compare teaser is set via configuration
   */
  public resolve$(): Observable<boolean> {
    return this.store.select(fromCarl.selectConfig('compareTeaser.display', false)).pipe(first());
  }
}
